import { Button, Flex, Icon, Link, Text } from '@chakra-ui/react';
import { Section } from '@/components/shared';
import { Trans, useTranslation } from 'react-i18next';
import { MbeInfo } from '@/components/icons';
import { ROUTE_PATHS } from '@/constants';

export const DocumentNotFound = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Section
      containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
      headingProps={{ mt: 0 }}
      id="not-found-message"
    >
      <Flex
        alignItems="center"
        direction="column"
        gap={6}
        px={{ base: 8, md: 16, xl: 44 }}
        py={{ base: 10, md: 24 }}
      >
        <Icon as={MbeInfo} color="brand.red.light" h={14} w={14} />
        <Text fontSize={{ base: 'h1.base', md: 'h1.mb' }} fontWeight="bold" textAlign="center">
          {t('COMMUNICATIONS.DOCUMENT_NOT_FOUND.TITLE')}
        </Text>
        <Text fontSize={{ base: 'p.base', md: 'p.mb' }} textAlign="center">
          <Trans i18nKey={'COMMUNICATIONS.DOCUMENT_NOT_FOUND.MESSAGE'} />
        </Text>
        <Text fontSize={{ base: 'p.base', md: 'p.mb' }} textAlign="center">
          <Trans
            components={{
              url: <Link color="brand.red.light" href={`/${ROUTE_PATHS.userLogin}`} />,
            }}
            i18nKey={'COMMUNICATIONS.DOCUMENT_NOT_FOUND.AUTH_MESSAGE'}
          />
        </Text>
        <Button as="a" href={`/${ROUTE_PATHS.manageDetails}`} mt={8} variant="mbeSecondary">
          {t('COMMUNICATIONS.DOCUMENT_NOT_FOUND.CTA')}
        </Button>
      </Flex>
    </Section>
  );
};
